(() => {
  const instances = new Map();
  const distance = (a, b) => {
    const rad = Math.PI / 180;
    const h = Math.sin((b.lat - a.lat) * rad / 2) ** 2 + Math.cos(a.lat * rad) * Math.cos(b.lat * rad) * Math.sin((b.lng - a.lng) * rad / 2) ** 2;
    return 6371 * 2 * Math.atan2(Math.sqrt(h), Math.sqrt(1 - h));
  };
  const element = (tag, text, className) => {
    const el = document.createElement(tag);
    if (text) el.textContent = text;
    if (className) el.className = className;
    return el;
  };
  const normalize = rows => (Array.isArray(rows) ? rows : []).filter(row => row && row.name && row.address && String(row.lat ?? '').trim() && String(row.lng ?? '').trim() && Number.isFinite(Number(row.lat)) && Number.isFinite(Number(row.lng)) && Math.abs(Number(row.lat)) <= 90 && Math.abs(Number(row.lng)) <= 180).map(row => ({ name: String(row.name), address: String(row.address), lat: Number(row.lat), lng: Number(row.lng) }));
  function setup(root) {
    if (instances.has(root)) return;
    const lifetime = new AbortController();
    const on = (target, type, fn) => target.addEventListener(type, fn, { signal: lifetime.signal });
    const mapNode = root.querySelector('[data-store-map]');
    const status = root.querySelector('[data-store-status]');
    const empty = root.querySelector('[data-store-empty]');
    const results = root.querySelector('[data-store-results]');
    const choices = root.querySelector('[data-city-choices]');
    const more = root.querySelector('[data-store-more]');
    const form = root.querySelector('[data-store-search]');
    const submit = form.querySelector('button');
    const locate = root.querySelector('[data-locate-me]');
    let map, storeLayer, userMarker, currentLocation, stores = [], matches = [], visible = 3, active = true, searchVersion = 0, directoryFailed = false;
    try { stores = normalize(JSON.parse(root.querySelector('[data-store-directory]').textContent)); } catch { directoryFailed = true; }
    const route = store => `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(store.address)}`;
    function addPins() {
      if (!map) return;
      if (!storeLayer) storeLayer = L.layerGroup().addTo(map);
      storeLayer.clearLayers();
      stores.forEach(store => {
        const content = element('div');
        content.append(element('strong', store.name), element('div', store.address));
        const a = element('a', window.BrioI18n.t('s_54ef40e2a9d3_html')); a.href = route(store); a.target = '_blank'; a.rel = 'noopener'; content.append(a);
        L.marker([store.lat, store.lng], { title: store.name, icon: L.divIcon({ className: 'brio-store-pin', html: '<span><b>B</b></span>', iconSize: [34, 44], iconAnchor: [17, 42] }) }).bindPopup(content).addTo(storeLayer);
      });
    }
    function frameMap() {
      if (!map) return;
      const narrow = window.matchMedia('(max-width:600px)').matches;
      if (currentLocation) {
        map.setView([currentLocation.lat, currentLocation.lng], 11, { animate: false });
        if (!narrow) map.panBy([mapNode.clientWidth * .22, 0], { animate: false });
      } else map.fitBounds([[42.25,-5.2],[51.15,8.5]], { animate: false, paddingTopLeft: [15,15], paddingBottomRight: [narrow ? 15 : mapNode.clientWidth * .45, 30] });
    }
    function initMap() {
      if (map || !active) return;
      if (!window.L) { status.textContent = window.BrioI18n.t('s_1bbce37a49ce_html'); return; }
      map = L.map(mapNode, { scrollWheelZoom: false, zoomControl: false, zoomSnap: 0.1 });
      L.tileLayer(root.dataset.tileUrl, { maxZoom: 18, attribution: '© <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener">OpenStreetMap</a>' }).addTo(map);
      L.control.zoom({ position: 'bottomleft' }).addTo(map);
      frameMap();
      addPins();
    }
    // Start tile requests before the section enters the viewport so the map is ready on arrival.
    const observer = new IntersectionObserver(entries => { if (entries.some(entry => entry.isIntersecting)) { initMap(); observer.disconnect(); } }, { rootMargin: '1200px 0px' });
    observer.observe(root);
    const resize = new ResizeObserver(() => { if (map) { map.invalidateSize({ pan: false }); frameMap(); } }); resize.observe(mapNode);
    const ready = (async () => {
      if (root.dataset.directoryUrl) {
        try {
          const response = await fetch(root.dataset.directoryUrl, { signal: lifetime.signal });
          if (!response.ok) throw new Error('directory');
          const data = await response.json();
          if (!active) return;
          stores = normalize(data.stores || data); addPins();
        } catch (error) { if (error.name !== 'AbortError') directoryFailed = true; }
      }
      empty.hidden = stores.length > 0;
      status.textContent = stores.length ? window.BrioI18n.t('s_1a228c25fdfb_html') : window.BrioI18n.t('s_c61afea21837_html');
    })();
    function renderResults() {
      results.replaceChildren();
      matches.slice(0, visible).forEach(store => {
        const item = element('article', '', 'brio-store-result');
        const km = new Intl.NumberFormat(window.BrioI18n.locale, { maximumFractionDigits: 1 }).format(store.distance);
        item.append(element('strong', store.name), element('small', `${km} km`), element('p', store.address));
        const a = element('a', window.BrioI18n.t('s_54ef40e2a9d3_html')); a.href = route(store); a.target = '_blank'; a.rel = 'noopener'; item.append(a); results.append(item);
      });
      more.hidden = matches.length <= visible;
    }
    async function showLocation(location, label) {
      await ready;
      if (!active) return;
      currentLocation = location; initMap(); choices.replaceChildren();
      if (map) {
        userMarker?.remove();
        userMarker = L.circleMarker([location.lat, location.lng], { radius: 7, color: '#fff', weight: 3, fillColor: '#005441', fillOpacity: 1 }).addTo(map).bindTooltip(label);
        frameMap();
      }
      matches = stores.map(store => ({ ...store, distance: distance(location, store) })).filter(store => store.distance <= 50).sort((a,b) => a.distance-b.distance);
      visible = 3; renderResults(); empty.hidden = stores.length > 0;
      status.textContent = !stores.length ? `${label} : ${directoryFailed ? window.BrioI18n.t('s_886d3d1d645a_html') : window.BrioI18n.t('s_e1875d0aef99_html')}.` : matches.length ? window.BrioI18n.t('s_149f57887e0f_html', {count: matches.length, place: label}) : window.BrioI18n.t('s_09cd889ab82e_html', {place: label});
    }
    on(form, 'submit', async event => {
      event.preventDefault(); const value = form.elements.city.value.trim(); if (value.length < 2) return;
      const version = ++searchVersion; submit.disabled = true; choices.replaceChildren(); status.textContent = window.BrioI18n.t('s_90a0d4b54b78_html');
      try {
        const params = new URLSearchParams({ fields: 'nom,centre,codesPostaux', boost: 'population', limit: '5' });
        params.set(/^\d{5}$/.test(value) ? 'codePostal' : 'nom', value);
        const response = await fetch(`https://geo.api.gouv.fr/communes?${params}`, { signal: lifetime.signal });
        if (!response.ok) throw new Error('city');
        const cities = (await response.json()).filter(city => Array.isArray(city.centre?.coordinates));
        if (!active || version !== searchVersion) return;
        if (!cities.length) { status.textContent = window.BrioI18n.t('s_14a8102af510_html'); return; }
        const choose = city => showLocation({ lng: city.centre.coordinates[0], lat: city.centre.coordinates[1] }, city.nom);
        if (cities.length === 1) await choose(cities[0]);
        else {
          status.textContent = window.BrioI18n.t('s_7356ce1aae83_html');
          cities.forEach(city => { const button = element('button', `${city.nom} (${city.codesPostaux?.[0] || ''})`); button.type = 'button'; on(button, 'click', () => choose(city)); choices.append(button); });
          choices.querySelector('button')?.focus();
        }
      } catch (error) { if (error.name !== 'AbortError' && version === searchVersion) status.textContent = window.BrioI18n.t('s_028cea764509_html'); }
      finally { if (active && version === searchVersion) submit.disabled = false; }
    });
    on(locate, 'click', () => {
      if (!navigator.geolocation) { status.textContent = window.BrioI18n.t('s_bffba87367c6_html'); return; }
      const version = ++searchVersion; submit.disabled = false; locate.disabled = true; status.textContent = window.BrioI18n.t('s_f19026a50bd6_html');
      navigator.geolocation.getCurrentPosition(position => { locate.disabled = false; if (active && version === searchVersion) showLocation({ lat: position.coords.latitude, lng: position.coords.longitude }, window.BrioI18n.t('s_89502415b8b3_html')); }, () => { locate.disabled = false; if (active && version === searchVersion) status.textContent = window.BrioI18n.t('s_e0107d95cebe_html'); }, { timeout: 10000, maximumAge: 60000, enableHighAccuracy: false });
    });
    on(more, 'click', () => { visible += 3; renderResults(); });
    instances.set(root, () => { active = false; lifetime.abort(); observer.disconnect(); resize.disconnect(); map?.remove(); instances.delete(root); });
  }
  const scan = scope => { if (scope.matches?.('[data-brio-locator]')) setup(scope); scope.querySelectorAll('[data-brio-locator]').forEach(setup); };
  scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => { for (const [root, dispose] of instances) if (event.target.contains(root)) dispose(); });
})();
